/**
 * SHA-256 of each binary schema this bundle reads FlatBuffers with, as LN2E
 * frames and `X-LN2-Schema` headers carry them: a frame or response whose
 * hash is one of these was written with this bundle's own schema.
 *
 * Generated by `npm run generate:schema-hashes` from the schemas embedded in
 * `src/flatbuffers/generated/`. Do not edit; a test fails when it is stale.
 */

/** `FrontEnd.FrontEndMessage`: single monitoring messages. */
export const FRONT_END_MESSAGE_SCHEMA_HASH =
  "6241d1a58b776bb94df4b220dfbf582581986196faa2dd8bfdbc6217873cb8fc";

/** `BatchedFrontEnd.BatchedFrontEndMessage`: the monitoring WebSocket's batches. */
export const BATCHED_FRONT_END_MESSAGE_SCHEMA_HASH =
  "12650f8192e0baa2c720f777142d583bfea0f8df6a41f70709f9deb01ef30e30";

/** `Api.ApiSchema`: every FlatBuffer HTTP body's type (`X-LN2-Schema`). */
export const API_SCHEMA_HASH = "479dbb0e897acc53b707e5b23a3e7eb1431f61b9ef10a1c00beed7ae9d6b4124";
